export const fonts = {
  default: 'pp-agrandir',
  default_grand_heavy: 'pp-agrandir-grand-heavy',
  secondary: 'Inter, sans-serif',
  code: 'monospace',
};
